import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class ButtonIcon extends React.Component {
  render() {
    const defaultColor = "rgba(255, 255, 255, 0.3)";
    const redColor = "rgba(255, 0, 0, 0.3)";
    const greenColor = "rgba(0, 255, 0, 0.3)";
    const dangerColor = "rgb(216, 27, 27)";

    return (
      <div
        title={this.props.title}
        aria-label={this.props.title}
        role="button"
        style={{
          position: "relative",
          display: "inline-flex",
          verticalAlign: "middle",
          backgroundColor: this.props.danger
            ? dangerColor
            : this.props.red
            ? redColor
            : this.props.green
            ? greenColor
            : defaultColor,
          height: this.props.height ? this.props.height : "60px",
          width: this.props.width ? this.props.width : "60px",
          borderRadius: "30px",
          fontSize: this.props.fontSize ? this.props.fontSize : "16px",
          cursor: "pointer",
          margin: this.props.separated ? "0.5rem 0.5rem 0.5rem 2.5rem" : "0.5rem",
        }}
        onClick={this.props.onClick}
      >
        <FontAwesomeIcon style={{ margin: "auto" }} icon={this.props.icon} />
        {this.props.badge ? (
          <div
            style={{
              position: "absolute",
              top: "-4px",
              right: "-4px",
              backgroundColor: "red",
              color: "#fff",
              borderRadius: "10px",
              minWidth: "18px",
              height: "18px",
              fontSize: "11px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 4px",
            }}
          >
            {this.props.badge}
          </div>
        ) : null}
      </div>
    );
  }
}

export function ToolbarSeparator() {
  return (
    <span
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        width: "1px",
        height: "32px",
        margin: "0 0.35rem",
        backgroundColor: "rgba(255, 255, 255, 0.25)",
      }}
    />
  );
}
